import {API} from './Api';

 async function LoginRequest(reqObj){
    return  API.post(`/users/auth`,reqObj);
}

async function VerifyRequest(reqObj){
    return  API.post(`/users/auth/verification`,reqObj);
}

async function SubscribeToTopic(reqObj){
    return  API.post(`/users/current/subscribe-to-topics`,reqObj);
}

async function getUser(){
    const token = localStorage.getItem('token')
    return  API.get(`/users/`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function getMallWithSubDomain(sub){
    const token = localStorage.getItem('token')
    return  API.get(`/malls/subdomain/${sub}`);
}

async function editUser(userObj){
    const token = localStorage.getItem('token')
    return API.put(`/users/`,userObj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function userProfile(file){
    const token = localStorage.getItem('token')
    return API.put(`/users/image`,file,{
        headers: {
            'Authorization':  `Bearer ${token}`,
            'content-type': 'multipart/form-data'
        }
    });
}

export {
     LoginRequest,
    VerifyRequest,
    SubscribeToTopic,
    userProfile,
    editUser,
    getUser,
    getMallWithSubDomain
};

